import { MeiliSearch } from "meilisearch";

export function getClient() {
  const host = process.env.NEXT_PUBLIC_SEARCHSERVER ?? "";
  const apiKey = process.env.NEXT_PUBLIC_SEARCHKEY;

  return new MeiliSearch({ host, apiKey });
}

export function getIndex(site: number) {
  return getClient().index(site === 1 ? "1-site" : "2-site");
}
